import './styles/contact-us.css'
import ContactForm from "./ContactForm"

export default function ContactUs() {
  return (
    <div id='contact-us' className='contact-us'>
        <div className="container">
            <div className="contact-us__head">
                <div className="contact-us__label">
                contact us
                </div>
                <div className="contact-us__title">
                Get in touch
                </div>
                <div className='contact-us__text'>
                We love to hear back from our customers! Please fill 
                out the form with any inquiries about our service, 
                and we will get back to you shortly.
                </div>
            </div>
            <ContactForm/>
        </div>
    </div>
  )
}
